import { createSelector } from 'reselect';
import { getAllFiles } from './getAllFiles';
const getFilesIds = (state, fileIds) => fileIds;
const isFileIdExists = (ids, file) => !!file && ids.includes(file.id);
export const getFilesByIds = createSelector([getAllFiles, getFilesIds], (allFiles, fileIds) => {
    return allFiles.filter(file => isFileIdExists(fileIds, file) || isFileIdExists(fileIds, file.thumbnail));
});
//# sourceMappingURL=getFilesByIds.js.map